import { render, staticRenderFns } from "./yhubPieChart.vue?vue&type=template&id=a36aa6da"
import script from "./yhubPieChart.vue?vue&type=script&lang=js"
export * from "./yhubPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports